<template>
  <div class="container" :style="{border: borderColor}"
       @click="$emit('click', id)">
    <div class="content">
      <i :class="icon" class="fa icon brand-primary" aria-hidden="true"></i>
      <div class="description" v-html="decodeData(description)" />
    </div>
    <div class="right-arrow bg-brand-primary bg-brand-primary">
      <i class="fa fa-arrow-right" aria-hidden="true"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavigationCard",
  props: {
    description: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: ""
    },
    optionNumber: {
      type: Number,
      default: 0
    },
    id: {
      type: Number,
      default: 0,
    },
    borderColor: {
      type: String,
      default: "1px solid #E0E5F5"
    },
  },
  methods: {
    decodeData(data) {
      try {
        return atob(data);
      } catch (error) {
        return data;
      }
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px;
  padding: 25px;
  gap: 5px;
  cursor: pointer;
}

.content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.icon {
  font-size: 4rem;
}

.right-arrow {
  text-align: center;
  color: #FFF;
  border-radius: 100px;
  
  .fa {
    font-size: 2.2rem;
    padding: 14px 16px;
  }
}

.description {
  font-size: 20px;
  max-width: 480px;
}
</style>